import { render, staticRenderFns } from "./Expert.vue?vue&type=template&id=56847b86&scoped=true"
import script from "./Expert.vue?vue&type=script&lang=js"
export * from "./Expert.vue?vue&type=script&lang=js"
import style0 from "./Expert.vue?vue&type=style&index=0&id=56847b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56847b86",
  null
  
)

export default component.exports